import { render } from "./RedirectButton.vue?vue&type=template&id=ae520a9c"
import script from "./RedirectButton.vue?vue&type=script&lang=js"
export * from "./RedirectButton.vue?vue&type=script&lang=js"

import "./RedirectButton.vue?vue&type=style&index=0&id=ae520a9c&lang=css"

import exportComponent from "/home/runner/work/tre/tre/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__